@if (isVisible) {
  <form-control [question]="componentData" [flow]="flowComponent">
    <input #input lunaInput [id]="controlId" [name]="controlName" type="text"
      [(ngModel)]="contextValue" [formControl]="formGroup.controls[componentData.key]" [placeholder]="inputMask"
      (blur)="onBlur($event)" (select)="onTextSelected($event)" (click)="onClick($event)" (keyup)="onKeyUp($event)" (keypress)="checkInput($event)"  (paste)="phonePasted($event)" />
    </form-control>
  }
